module.exports = __webpack_public_path__ + "media/images/icon_info-7bd7f7ec63ab630db5e769d6451b7370.png";